<template>
  <v-container
    v-if="checklist"
    id="print-wrapper"
    class="white"
  >
    <checklist-view :checklist="checklist" />
  </v-container>
</template>

<script>
  import Checklist from '@/models/Checklist'
  import ChecklistView from '@/components/service/checklists/ChecklistView'

  export default {
    name: 'ChecklistPrint',
    components: {
      ChecklistView
    },
    data() {
      return {
        checklist: null,
        loading: false
      }
    },
    created() {
      this.fetchChecklist()
    },
    methods: {
      async fetchChecklist() {
        this.loading = true

        try {
          this.checklist = await Checklist.api.get(this.$route.params.id)

          this.print()
        } catch (e) {
          throw e
        } finally {
          this.loading = false
        }
      },
      print() {
        this.$nextTick(function () {
          setTimeout(() => {
            window.print()
            window.close()
          }, 300)
        })
      }
    }
  }
</script>
